import { z } from "zod";

import { ActivityAction } from "../enum/ActivityAction.enum";
import { ActivityTypes } from "../enum/ActivityTypes.enum";
// Comment schemas
export const TaskAndSubtaskCommentInfoSchema = z.object({
	id: z.number().optional(),
	type: z.nativeEnum(ActivityTypes),
	taskId: z.number().nullable().optional(),
	subtaskId: z.number().nullable().optional(),
	userId: z.number(),
	companyId: z.number().nullable().optional(),
	oldData: z.record(z.unknown()).nullable().optional(),
	newData: z.record(z.unknown()).nullable().optional(),
	content: z.string(),
	createdAt: z.date(),
	updatedAt: z.date().optional(),
	deletedAt: z.date().nullable().optional(),
});

export const CreateTaskAndSubtaskCommentSchema = z.object({
	type: z.nativeEnum(ActivityTypes),
	taskId: z.number().optional().nullable(),
	subtaskId: z.number().optional().nullable(),
	companyId: z.number().optional(),
	oldData: z.record(z.unknown()).optional(),
	newData: z.record(z.unknown()).optional(),
	content: z.string().min(1),
});

export const UpdateTaskAndSubtaskCommentSchema = z.object({
	content: z.string().min(1),
});

// History schemas
export const TaskAndSubtaskHistoryInfoSchema = z.object({
	id: z.number().optional(),
	type: z.nativeEnum(ActivityTypes),
	action: z.nativeEnum(ActivityAction),
	taskId: z.number().nullable().optional(),
	subtaskId: z.number().nullable().optional(),
	userId: z.number(),
	companyId: z.number().nullable().optional(),
	createdAt: z.date().optional(),
	updatedAt: z.date().optional(),
});

// Response schemas
export const TaskAndSubtaskCommentResponseSchema = z.array(TaskAndSubtaskCommentInfoSchema);
export const TaskAndSubtaskHistoryResponseSchema = z.array(TaskAndSubtaskHistoryInfoSchema);

// Types
export type TaskAndSubtaskCommentInfo = z.infer<typeof TaskAndSubtaskCommentInfoSchema>;
export type CreateTaskAndSubtaskComment = z.infer<typeof CreateTaskAndSubtaskCommentSchema>;
export type UpdateTaskAndSubtaskComment = z.infer<typeof UpdateTaskAndSubtaskCommentSchema>;
export type TaskAndSubtaskHistoryInfo = z.infer<typeof TaskAndSubtaskHistoryInfoSchema>;
export type TaskAndSubtaskCommentResponse = z.infer<typeof TaskAndSubtaskCommentResponseSchema>;
export type TaskAndSubtaskHistoryResponse = z.infer<typeof TaskAndSubtaskHistoryResponseSchema>;
